class Event {

    constructor(name, data)
    {
        this.name = name;
        this.data = data;
    }

}
export default Event;